import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXTwitter } from "@fortawesome/free-brands-svg-icons";

interface XCardProps {
  user: string;
  title: string;
  desc: string;
}

const XCard: React.FC<XCardProps> = ({ user, title, desc }) => {
  return (
    <div className="x-card">
      <div className="x-card-heading">
        <p className="x-card-user">{user}</p>
        <span className="x-card-logo">
          <FontAwesomeIcon icon={faXTwitter} />
        </span>
      </div>
      <h1 className="x-card-title">"{title}"</h1>
      <p className="x-card-desc">{desc}</p>
    </div>
  );
};

export default XCard;
